<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row" v-if="userData.permissions['view_products']==1"> 
  
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2" v-if="userData.canteen!=''">
                <h5>{{ userData.canteen.name }} <span class="h6">| <i class="mdi mdi-phone"></i> {{ userData.canteen.telephone }}</span></h5>
                <b-button v-show="userData" v-b-modal.new-products size="sm" variant="primary"><i class="mdi mdi-plus"></i> New  Product</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(canteen)="data"> {{ data.item.canteen.name }}</template>
                <template #cell(product_image)="data">
                  <img :src="getFiles(data.item.product_image)" height="50"/>
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data" v-if="userData.canteen!=''">
                  <div class="btn-group">
                  <b-button v-if="userData.canteen.id==data.item.canteen.id" @click="edit(data.item.id,data.item.name ,data.item.description,data.item.price,data.item.product_image)" type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button v-if="userData.canteen.id==data.item.canteen.id" @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-products" centered title="New  Product" title-class="font-18" hide-footer>
          <form @submit.prevent="addproducts">
              <div class="form-group mb-2">
                <div class="form-group">
              <label>Canteen</label>
              <input :value="userData.canteen.name" type="text" readonly class="form-control" />
              </div>
              <label>Name</label>
              <input v-model="name" type="text" class="form-control" />
              <label>Description</label>
              <textarea v-model="description" type="text" row="7" class="form-control"></textarea>
              <label>Price</label>
              <input v-model="price" type="number" :min="0" class="form-control" />
              <label>Photo</label>
              <input id="product_image" type="file" class="form-control"  @change="handleImage"/>
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-products')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-products" centered title="Edit  Product" title-class="font-14" hide-footer>
          <form @submit.prevent="editproducts">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label>Product Name</label>
              <input v-model="name" type="text" class="form-control" />
              <label>Description</label>
              <textarea v-model="description" type="text" row="7" class="form-control"></textarea>
              <label>Price</label>
              <input v-model="price" type="number" :min="0" class="form-control" />
              <!-- <label>Photo</label>
              <input id="product_image" type="file" class="form-control" @change="handleImage" /> -->
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-products')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-products" centered title="Delete Product" title-class="font-18" hide-footer>
          <form @submit.prevent="removeproducts">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the products : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-products')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
    </div>  
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
          </div>
        </div>
      </div>
    </div>   
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  // import Multiselect from "vue-multiselect";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { productsMethods, productsComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Canteen Products",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Canteen Products",
        items: [ {text: "Dashboard",to: "/",}, {text: "Canteen Products",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'canteen', label: 'Canteen', visible: true },
           { key: 'product_image', label: 'Photo', visible: true },
            { key: 'name', label: 'Name', visible: true },
            { key: 'price', label: 'Price', visible: true },
            { key: 'description', label: 'Description', visible: true },
            { key: 'addedby', label: 'Added by', visible: true },
            { key: 'addedon', label: 'Date added', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        name:'',price:'',description:'',product_image:'',canteen:'',
      };
    },
    computed: {
      ...productsComputed,
      List() { return this.products.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.products.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.products.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchProducts();
      this.TotalRows = this.products.length;
      this.isBusy=false;
    },
    methods: {
      ...productsMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name,description,price,product_image){
        this.id=id;
        this.name=name;
        this.description=description;
        this.price=price;
        this.product_image=product_image;
        this.$bvModal.show('edit-products')
      },
      remove(id){
        this.id=id;
        this.$bvModal.show('delete-products')
      },
      async addproducts() { 
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("description", this.description);
        formData.append("price", this.price);
        formData.append('product_image',this.product_image);
        let url = "/addproducts";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchProducts();
            this.$bvModal.hide('new-products');
            this.$swal({ title:'Success',text:this.name+" Added Successfully", icon:'success'});
        }
        });
      },
      async editproducts(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("price", this.price);
      formData.append('description',this.description);
      formData.append('product_image',this.product_image);
      let url = "/updateproducts";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchProducts();
          this.$bvModal.hide('edit-products');
          this.$swal({ title:'Success', text:this.name+" Edited Successfully", icon:'success'});
        }
      });
      },
      async removeproducts() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeproducts";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchProducts();
          this.$bvModal.hide('delete-products');
          this.$swal({ title:'Success', text:" Deleted Successfully", icon:'success'});
        }
      });
      },
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"products/"+name;
      return imagelink;
    },
    handleImage(e){ this.product_image = e.target.files[0]; },
    },
  };
  </script>